var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient0, _clipPath, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdaptiveflowspec(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: "1em",
    viewBox: "0 0 86 54",
    width: "1em",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "adaptiveflowspec_svg__a"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d05c32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3980e5"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "adaptiveflowspec_svg__d",
    gradientUnits: "userSpaceOnUse",
    x1: 25.87,
    x2: 25.87,
    xlinkHref: "#adaptiveflowspec_svg__a",
    y1: 4.627,
    y2: 47.403
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "adaptiveflowspec_svg__b"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5cb765"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1b6f89"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "adaptiveflowspec_svg__e",
    gradientUnits: "userSpaceOnUse",
    x1: 29.826,
    x2: 29.826,
    xlinkHref: "#adaptiveflowspec_svg__b",
    y1: 0,
    y2: 42.328
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "adaptiveflowspec_svg__f",
    gradientUnits: "userSpaceOnUse",
    x1: 25.296,
    x2: 25.296,
    xlinkHref: "#adaptiveflowspec_svg__a",
    y1: -3.277,
    y2: 42.698
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "adaptiveflowspec_svg__g",
    gradientUnits: "userSpaceOnUse",
    x1: 28.361,
    x2: 28.361,
    xlinkHref: "#adaptiveflowspec_svg__b",
    y1: -8.25,
    y2: 37.244
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "adaptiveflowspec_svg__h",
    gradientUnits: "userSpaceOnUse",
    x1: 60.067,
    x2: 60.067,
    xlinkHref: "#adaptiveflowspec_svg__a",
    y1: 49.346,
    y2: 6.57
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "adaptiveflowspec_svg__i",
    gradientUnits: "userSpaceOnUse",
    x1: 56.112,
    x2: 56.112,
    xlinkHref: "#adaptiveflowspec_svg__b",
    y1: 53.974,
    y2: 11.645
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "adaptiveflowspec_svg__j",
    gradientUnits: "userSpaceOnUse",
    x1: 60.642,
    x2: 60.642,
    xlinkHref: "#adaptiveflowspec_svg__a",
    y1: 57.25,
    y2: 11.275
  })), _linearGradient0 || (_linearGradient0 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "adaptiveflowspec_svg__k",
    gradientUnits: "userSpaceOnUse",
    x1: 57.577,
    x2: 57.577,
    xlinkHref: "#adaptiveflowspec_svg__b",
    y1: 62.224,
    y2: 16.73
  })), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "adaptiveflowspec_svg__c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h86v54H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#adaptiveflowspec_svg__c)"
  }, /*#__PURE__*/React.createElement("g", {
    clipRule: "evenodd",
    fillRule: "evenodd",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.367 0L21.309 33.763l6.291 6.19H2.437v-24.77l6.267 6.17L30.084 0H25.87L8.293 17.527-.062 9.303v33.025h33.548L25.1 34.075 59.714 0z",
    fill: "url(#adaptiveflowspec_svg__d)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.367 0L21.309 33.763l6.291 6.19H2.437v-24.77l6.267 6.17L30.084 0H25.87L8.293 17.527-.062 9.303v33.025h33.548L25.1 34.075 59.714 0z",
    fill: "url(#adaptiveflowspec_svg__e)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.96 33.387L51.52-.923 43.467-8.25 9.105 25.653 5.201 21.81v15.434h15.678z",
    fill: "url(#adaptiveflowspec_svg__f)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.96 33.387L51.52-.923 43.467-8.25 9.105 25.653 5.201 21.81v15.434h15.678z",
    fill: "url(#adaptiveflowspec_svg__g)"
  })), /*#__PURE__*/React.createElement("g", {
    clipRule: "evenodd",
    fillRule: "evenodd",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.57 53.974L64.629 20.21l-6.29-6.19H83.5v24.77l-6.267-6.169-21.38 21.352h4.215l17.577-17.527L86 44.671V11.645H52.451l8.388 8.253-34.615 34.075z",
    fill: "url(#adaptiveflowspec_svg__h)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.57 53.974L64.629 20.21l-6.29-6.19H83.5v24.77l-6.267-6.169-21.38 21.352h4.215l17.577-17.527L86 44.671V11.645H52.451l8.388 8.253-34.615 34.075z",
    fill: "url(#adaptiveflowspec_svg__i)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.978 20.587l-34.562 34.31 8.055 7.326L76.832 28.32l3.905 3.844V16.73H65.058z",
    fill: "url(#adaptiveflowspec_svg__j)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.978 20.587l-34.562 34.31 8.055 7.326L76.832 28.32l3.905 3.844V16.73H65.058z",
    fill: "url(#adaptiveflowspec_svg__k)"
  })))));
}
export default "data:image/svg+xml;base64,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";
export { SvgAdaptiveflowspec as ReactComponent };